import ContentGroupSection from './ContentGroupSection';

export default ContentGroupSection;
